import React from "react";

export default (props: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => {
    return (
        <img
            className="keno-logo"
            { ...props }
            src={ require("../static/images/ogs-keno-logo.png") }
            alt="Keno"
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/KenoLogo.tsx